/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Link20 from '@carbon/icons-react/es/link/20';
import React, { FC, useRef } from 'react';
import {
  useDocuments,
  setBalloonToolbarDetails,
  PopupType,
} from '../../document-store';
import styles from './link-handler.module.css';

export const LinkHandler: FC = () => {
  const [, dispatch] = useDocuments();
  const toolbarRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    const positions = toolbarRef?.current?.getBoundingClientRect();

    // Adjusting the positions to palce the link form on top of balloon toolbar
    setBalloonToolbarDetails(dispatch, {
      type: PopupType.LinkForm,
      position: {
        x: positions ? positions.x + 119 : 0,
        y: positions ? positions?.y + 44 : 0,
      },
    });
  };

  return (
    <div ref={toolbarRef} onClick={handleClick} className={styles.link}>
      <Link20 />
    </div>
  );
};
